export default __webpack_public_path__ + "static/media/Numbers_01.782fca20.png";